;(() => {
  const faqsCategories = document.getElementById('faqs-categories')
  if (faqsCategories) {
    faqsCategories.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', (event) => {
        const activeCategory = event.target
          .getAttribute('id')
          .split('category-')[1]

        setActiveStyling(event)
        toggleRelevantAccordions(activeCategory)
      })
    })
  }

  function toggleRelevantAccordions(activeCategory) {
    document
      .querySelectorAll('section.faqs .accordion-wrapper')
      .forEach((accordion) => {
        if (activeCategory === 'all') {
          accordion.style.display = 'block'
        } else if (
          accordion.getAttribute('data-categories').includes(activeCategory)
        ) {
          accordion.style.display = 'block'
        } else {
          accordion.style.display = 'none'
        }
      })
  }

  function setActiveStyling(event) {
    faqsCategories
      .querySelectorAll('button')
      .forEach((button) => button.classList.remove('active'))
    event.target.classList.add('active')
  }
})()
